import React from 'react';
import { TextVariant } from '@naf/text';
import { BenefitBulletsCard } from '@components/BenefitBulletsCard/BenefitBulletsCard';
import * as S from './BenefitTitle.styles';

interface BenefitTitleProps {
  id?: string;
  slug?: string;
  title: string;
  ingress?: string;
  isFavorite?: boolean;
  keyInformation?: {
    title?: string;
    items?: string[];
  };
}

export const BenefitTitle = ({ id, slug, title, ingress, isFavorite, keyInformation }: BenefitTitleProps) => (
  <>
    <S.StyledHeaderText tag="h1" variant={TextVariant.Display}>
      {title}
    </S.StyledHeaderText>
    {ingress && (
      <S.IngressWrapper>
        <S.Ingress tag="p" variant={TextVariant.Ingress}>
          {ingress}
        </S.Ingress>
        <S.HRLine />
        {keyInformation && (
          <S.MobileWrapper>
            <BenefitBulletsCard
              id={id}
              slug={slug}
              title={keyInformation.title || 'Hva får du?'}
              benefitTitle={title}
              bullets={keyInformation.items}
              isFavorite={isFavorite}
            />
          </S.MobileWrapper>
        )}
      </S.IngressWrapper>
    )}
  </>
);
